export const translations = {
  ar: {
    // Header
    adminPanel: "لوحة الإدارة",

    // Map Controls
    changeMapStyle: "تغيير نوع الخريطة",
    changeLanguage: "تغيير اللغة",
    changeSidebarPosition: "تغيير موقع القائمة الجانبية",
    zoomIn: "تكبير",
    zoomOut: "تصغير",
    resetView: "العودة للعرض الأساسي",
    home: "الرئيسية",

    // Map Styles
    streets: "شوارع",
    satellite: "قمر صناعي",
    outdoors: "خارجي",

    // Loading Messages
    loadingProjects: "جاري تحميل المشاريع...",
    loadingBlocks: "جاري تحميل البلوكات...",
    loadingParcels: "جاري تحميل الوحدات...",
    loadingMapLayers: "جاري تحميل طبقات الخريطة...",
    loadingLayers: "جاري تحميل الطبقات...",
    loadingLandmarks: "جاري تحميل المعالم...",
    updatingMap: "جاري تحديث الخريطة...",
    allDataLoaded: "تم تحميل جميع البيانات بنجاح!",
    loadingError: "حدث خطأ أثناء تحميل البيانات",

    // Unit Details
    parcel: "وحدة",
    area: "المساحة",
    status: "الحالة",
    price: "السعر",
    type: "النوع",
    view: "الإطلالة",
    available: "متاح",
    notAvailable: "غير متوفر",
    reserved: "محجوز",
    sold: "مباع",

    // Block Details
    block: "بلوك",
    blockNumber: "رقم البلوك",

    // Floor Details
    floors: "الطوابق",
    floor: "طابق",
    floorNumber: "رقم الطابق",
    availableFloors: "الطوابق المتاحة",
    groundFloor: "الطابق الأرضي",
    firstFloor: "الطابق الأول",
    allFloors: "جميع الطوابق",

    // General
    noDataAvailable: "لا توجد بيانات متاحة",
    showOnMap: "عرض على الخريطة",
    selectProject: "اختر مشروع",

    // Project Selector
    project: "مشروع",
    selectProjectPlaceholder: "اختر مشروعاً...",

    // Unit Card
    closeCard: "إغلاق الكارت",
    parcelImage: "صورة الوحدة",
    residential: "سكني",
    commercial: "تجاري",
    industrial: "صناعي",

    // Detailed Unit Information
    parcelNumber: "رقم الوحدة",
    pricePerSqm: "السعر للمتر المربع",
    totalPrice: "السعر الإجمالي",
    propertyType: "نوع الوحدة",
    usageType: "نوع الاستخدام",
    plotCondition: "حالة الوحدة",
    expectedRoi: "العائد المتوقع",
    deliveryDate: "تاريخ التسليم",
    downPayment: "الدفعة المقدمة",
    paymentTerms: "شروط الدفع",
    infrastructure: "البنية التحتية",
    services: "الخدمات المتاحة",

    // Property Types
    land: "أرض",
    villa: "فيلا",
    apartment: "شقة",

    // Plot Conditions
    fenced: "مسورة",
    ready: "جاهزة",
    underDevelopment: "تحت التطوير",

    // Infrastructure Status
    completed: "مكتملة",
    inProgress: "قيد التنفيذ",
    planned: "مخططة",

    // Views
    mainRoad: "شارع رئيسي",
    garden: "حديقة",
    mountain: "جبل",
    sea: "بحر",
    internalStreet: "شارع داخلي",

    // Search
    searchingParcel: "جاري البحث عن الوحدة...",

    // New Unit Card
    unitNumber: "رقم الوحدة",
    blockNumber: "رقم البلوك",
    areaLabel: "المساحة",
    priceLabel: "السعر",
    reserveUnit: "حجز الوحدة",
    available: "متاح",
    notAvailable: "غير متوفر",
    sqm: "متر مربع",
    sar: "ريال",

    // Terms and Conditions
    termsNotificationTitle: "إخلاء مسؤولية",
    termsNotificationMessage: "إذا قمت بالاستمرار في استخدام هذا الموقع فإنك توافق على الشروط والأحكام",
    readTerms: "قراءة",
    agreeTerms: "موافق",
    closeTerms: "إغلاق",
    termsModalTitle: "إخلاء مسؤولية",

    // Virtual Tour
    virtualTour: "جولة افتراضية",
    share: "مشاركة",
    liveCamera: "كاميرا مباشرة",
    addToFavorites: "إضافة للمفضلة",
    removeFromFavorites: "إزالة من المفضلة",
    favorites: "المفضلة",

    // Project Timeline
    launchDate: "تاريخ الإطلاق",
    completionDate: "تاريخ التسليم المتوقع",
    constructionProgress: "تقدم الإنشاءات",

    // Sidebar Position
    sidebarPositionAuto: "تلقائي (حسب اللغة)",
    sidebarPositionLeft: "يسار",
    sidebarPositionRight: "يمين",

    // Project Details Panel
    projectStatistics: "إحصائيات المشروع",
    totalUnits: "إجمالي الوحدات",
    availableUnits: "الوحدات المتاحة",
    priceRange: "نطاق الأسعار",
    totalArea: "إجمالي المساحة",
    exploreProject: "استكشف المشروع",

    termsContent: "تم إعداد هذا المخطط لأغراض العرض التوضيحي فقط، ويُستخدم لتقديم تصور عام عن موقع المشروع العقاري وتوزيع الأراضي أو الوحدات السكنية عليه، وذلك ضمن إطار خدمة RealMap التابعة لشركة idezinelab limited والمتخصصة في الحلول الهندسية والخرائط التفاعلية للمطورين العقاريين والمنصات العقارية. المخطط لا يُعد وثيقة قانونية أو فنية، ولا يتضمن أي التزامات تخص التصميم النهائي، أو تفاصيل البناء، أو التشطيبات، أو المرافق، أو الخدمات العامة، أو مساحات الأراضي أو الوحدات السكنية، أو نسب التملك، أو شروط البيع والشراء. كما أن العناصر المعمارية والديكورات والأثاث والحدائق ووسائل الراحة المعروضة ضمن الجولة الافتراضية أو الصور هي لأغراض العرض فقط، ولا تعكس الواقع بالضرورة، ولا تُعد جزءًا من العقد أو أي التزام من المطور العقاري. جميع الإحداثيات والمواقع المعروضة تقريبية وتم تقديمها من قبل المطور العقاري أو الجهة المالكة للمشروع، ولا تتحمل RealMap أو شركة idezinelab limited أي مسؤولية قانونية أو تعاقدية عن دقتها أو استخدامها خارج نطاق العرض الهندسي التفاعلي. يُنصح المستثمرون والمهتمون بالحصول على التفاصيل الدقيقة والنهائية مباشرة من المطور العقاري المعني، أو من خلال المستندات",

    // Reservation Modal
    unitDetails: "تفاصيل الوحدة",
    customerInfo: "معلومات العميل",
    phoneNumber: "رقم الهاتف",
    fullName: "الاسم الكامل",
    email: "البريد الإلكتروني",
    continue: "متابعة",
    paymentInfo: "معلومات الدفع",
    editInfo: "تعديل المعلومات",
    cardDetails: "تفاصيل البطاقة",
    totalAmount: "المبلغ الإجمالي",
    reservationAmount: "مبلغ الحجز",
    back: "رجوع",
    payNow: "ادفع الآن",
    sales: "المبيعات",
    contactSales: "تواصل مع المبيعات",

    // Login Modal
    login: "تسجيل الدخول",
    password: "كلمة المرور",
    loginWithGoogle: "تسجيل الدخول بجوجل",
    loginSuccess: "تم تسجيل الدخول بنجاح!",
    loginError: "خطأ في تسجيل الدخول",
    connectionError: "خطأ في الاتصال بالخادم",
    invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    enterEmail: "أدخل بريدك الإلكتروني",
    enterPassword: "أدخل كلمة المرور",
    or: "أو",

    // OTP System
    phoneNumber: "رقم الجوال",
    enterPhoneNumber: "أدخل رقم الجوال",
    sendOtp: "إرسال رمز التحقق",
    verifyPhone: "تحقق من رقم الجوال",
    enterOtpCode: "أدخل رمز التحقق",
    otpCode: "رمز التحقق",
    resendCode: "إعادة إرسال الرمز",
    otpSent: "تم إرسال رمز التحقق",
    otpVerified: "تم التحقق بنجاح",
    invalidOtp: "رمز التحقق غير صحيح",
    otpExpired: "انتهت صلاحية رمز التحقق",
    completeProfile: "استكمال الملف الشخصي",
    createAccount: "إنشاء الحساب",
    fullName: "الاسم الكامل",
    email: "البريد الإلكتروني",
    optional: "اختياري",
    accountCreated: "تم إنشاء الحساب بنجاح"
  },

  en: {
    // Header
    adminPanel: "Admin Panel",

    // Map Controls
    changeMapStyle: "Change Map Style",
    changeLanguage: "Change Language",
    changeSidebarPosition: "Change Sidebar Position",
    zoomIn: "Zoom In",
    zoomOut: "Zoom Out",
    resetView: "Reset View",
    home: "Home",

    // Map Styles
    streets: "Streets",
    satellite: "Satellite",
    outdoors: "Outdoors",

    // Loading Messages
    loadingProjects: "Loading projects...",
    loadingBlocks: "Loading blocks...",
    loadingParcels: "Loading units...",
    loadingMapLayers: "Loading map layers...",
    loadingLayers: "Loading layers...",
    loadingLandmarks: "Loading landmarks...",
    updatingMap: "Updating map...",
    allDataLoaded: "All data loaded successfully!",
    loadingError: "Error loading data",

    // Unit Details
    parcel: "Unit",
    area: "Area",
    status: "Status",
    price: "Price",
    type: "Type",
    view: "View",
    available: "Available",
    reserved: "Reserved",
    sold: "Sold",

    // Block Details
    block: "Block",
    blockNumber: "Block Number",

    // Floor Details
    floors: "Floors",
    floor: "Floor",
    floorNumber: "Floor Number",
    availableFloors: "Available Floors",
    groundFloor: "Ground Floor",
    firstFloor: "First Floor",
    allFloors: "All Floors",

    // General
    noDataAvailable: "No data available",
    showOnMap: "Show on Map",
    selectProject: "Select Project",

    // Project Selector
    project: "Project",
    selectProjectPlaceholder: "Select a project...",

    // Unit Card
    closeCard: "Close Card",
    parcelImage: "Unit Image",
    residential: "Residential",
    commercial: "Commercial",
    industrial: "Industrial",

    // Detailed Unit Information
    parcelNumber: "Unit Number",
    pricePerSqm: "Price per m²",
    totalPrice: "Total Price",
    propertyType: "Unit Type",
    usageType: "Usage Type",
    plotCondition: "Unit Condition",
    expectedRoi: "Expected ROI",
    deliveryDate: "Delivery Date",
    downPayment: "Down Payment",
    paymentTerms: "Payment Terms",
    infrastructure: "Infrastructure",
    services: "Services",

    // Property Types
    land: "Land",
    villa: "Villa",
    apartment: "Apartment",

    // Plot Conditions
    fenced: "Fenced",
    ready: "Ready",
    underDevelopment: "Under Development",

    // Infrastructure Status
    completed: "Completed",
    inProgress: "In Progress",
    planned: "Planned",

    // Views
    mainRoad: "Main Road",
    garden: "Garden",
    mountain: "Mountain",
    sea: "Sea",
    internalStreet: "Internal Street",

    // Search
    searchingParcel: "Searching for unit...",

    // New Unit Card
    unitNumber: "Unit Number",
    blockNumber: "Block Number",
    areaLabel: "Area",
    priceLabel: "Price",
    reserveUnit: "Reserve Unit",
    available: "Available",
    notAvailable: "Not Available",
    sqm: "sqm",
    sar: "SAR",

    // Terms and Conditions
    termsNotificationTitle: "Disclaimer",
    termsNotificationMessage: "By continuing to use this site, you agree to the terms and conditions",
    readTerms: "Read",
    agreeTerms: "Agree",
    closeTerms: "Close",
    termsModalTitle: "Disclaimer",

    // Virtual Tour
    virtualTour: "Virtual Tour",
    share: "Share",
    liveCamera: "Live Camera",
    addToFavorites: "Add to Favorites",
    removeFromFavorites: "Remove from Favorites",
    favorites: "Favorites",

    // Project Timeline
    launchDate: "Launch Date",
    completionDate: "Expected Completion",
    constructionProgress: "Construction Progress",

    // Sidebar Position
    sidebarPositionAuto: "Auto (Based on Language)",
    sidebarPositionLeft: "Left",
    sidebarPositionRight: "Right",

    // Project Details Panel
    projectStatistics: "Project Statistics",
    totalUnits: "Total Units",
    availableUnits: "Available Units",
    priceRange: "Price Range",
    totalArea: "Total Area",
    exploreProject: "Explore Project",

    termsContent: "This plan is used only for the purpose of providing an impression of the main plan of the project, in addition to finishing materials and the approximate location of facilities or services or to determine distances to nearby facilities from the project, and is not specialized in displaying the latest interior designs used in units and visualization as shown in the virtual tour is for illustration purposes only. The image of open residential units and furniture, fixtures, objects, electronic goods, amenities, landscapes and accessories including color schemes and so on specified here are only for the purpose of showing the general character of residential units. Dar and Emaar does not provide any guarantee regarding the future development displayed, or current or future amenities or location or the existence of any facilities or services or destinations. Details may change due to future circumstances, any determination of distance or size is approximate and for guidance purposes only, and is not to scale. All distances and travel time frames are estimates only. Dar and Emaar Real Estate Development Company provides a disclaimer that the virtual tour including amenities shown from each property does not constitute any part of the offer or sale and purchase contract.",

    // Reservation Modal
    unitDetails: "Unit Details",
    customerInfo: "Customer Information",
    phoneNumber: "Phone Number",
    fullName: "Full Name",
    email: "Email",
    continue: "Continue",
    paymentInfo: "Payment Information",
    editInfo: "Edit Information",
    cardDetails: "Card Details",
    totalAmount: "Total Amount",
    reservationAmount: "Reservation Amount",
    back: "Back",
    payNow: "Pay Now",
    sales: "Sales",
    contactSales: "Contact Sales",

    // Login Modal
    login: "Login",
    password: "Password",
    loginWithGoogle: "Login with Google",
    loginSuccess: "Login successful!",
    loginError: "Login failed",
    connectionError: "Connection error",
    invalidCredentials: "Invalid email or password",
    enterEmail: "Enter your email",
    enterPassword: "Enter your password",
    or: "OR",

    // OTP System
    phoneNumber: "Phone Number",
    enterPhoneNumber: "Enter phone number",
    sendOtp: "Send Verification Code",
    verifyPhone: "Verify Phone Number",
    enterOtpCode: "Enter verification code",
    otpCode: "Verification Code",
    resendCode: "Resend Code",
    otpSent: "Verification code sent",
    otpVerified: "Successfully verified",
    invalidOtp: "Invalid verification code",
    otpExpired: "Verification code expired",
    completeProfile: "Complete Profile",
    createAccount: "Create Account",
    fullName: "Full Name",
    email: "Email",
    optional: "Optional",
    accountCreated: "Account created successfully"
  },
};

export const getTranslation = (key, language = "ar") => {
  return translations[language]?.[key] || translations["en"]?.[key] || key;
};

/**
 * Format date using Gregorian calendar regardless of locale
 * تنسيق التاريخ باستخدام التقويم الميلادي بغض النظر عن اللغة
 */
export const formatGregorianDate = (dateString, language = "ar", options = {}) => {
  if (!dateString) return "N/A";

  try {
    const date = new Date(dateString);
    const defaultOptions = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      calendar: 'gregory' // Force Gregorian calendar
    };

    const formatOptions = { ...defaultOptions, ...options };
    const locale =  "en-US" ;//language === "ar" ? "ar-SA" : "en-US";

    return date.toLocaleDateString(locale, formatOptions);
  } catch (error) {
    console.warn('Error formatting date:', error);
    return dateString;
  }
};
